import { formatDate } from "@/lib/utils";
import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
} from "@a7y/tailwind-catalyst";
import { ReferralStateBadge, Section } from "../shared";
import type { AffiliateReferral } from "../types";

export function ReferralsTab({ referrals }: { referrals: AffiliateReferral[] }) {
  return (
    <Section title={`Referrals (${referrals.length})`}>
      <Table dense striped>
        <TableHead>
          <TableRow>
            <TableHeader>State</TableHeader>
            <TableHeader>Org</TableHeader>
            <TableHeader>Attribution</TableHeader>
            <TableHeader>Visits</TableHeader>
            <TableHeader>First seen</TableHeader>
            <TableHeader>Converted</TableHeader>
            <TableHeader>Flags</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {referrals.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} className="py-6 text-center">
                <Text className="text-sm text-zinc-500">No referrals yet</Text>
              </TableCell>
            </TableRow>
          ) : (
            referrals.map((r) => (
              <TableRow key={r.id}>
                <TableCell>
                  <ReferralStateBadge state={r.state} />
                </TableCell>
                <TableCell className="font-mono text-xs">{r.orgId || "—"}</TableCell>
                <TableCell className="text-sm text-zinc-500">
                  {r.attributionSource || "—"}
                </TableCell>
                <TableCell className="text-sm text-zinc-500">{r.visits}</TableCell>
                <TableCell className="text-sm text-zinc-500">{formatDate(r.firstSeenAt)}</TableCell>
                <TableCell className="text-sm text-zinc-500">
                  {r.convertedAt ? formatDate(r.convertedAt) : "—"}
                </TableCell>
                <TableCell>
                  {r.suspicious ? <Badge color="red">Suspicious</Badge> : <Badge color="zinc">—</Badge>}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Section>
  );
}
